const Field = (props) => {
  const { hidden, title, value } = props;

  return (
    !hidden && (
      <div>
        <div className="text-xs text-theme-text-tertiary">{title}</div>
        <div className="text-sm text-theme-text-secondary font-semibold break-words">
          {value}
        </div>
      </div>
    )
  );
};

export default Field;
